import { render } from "./VideoDetailsView.vue?vue&type=template&id=64282a5c"
import script from "./VideoDetailsView.vue?vue&type=script&lang=js"
export * from "./VideoDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__